class FormValidator {
  constructor(settings) {
    this.options = Object.assign({
      formsClass: '.form-validation',
      fieldsClass: '.element-validation',
      errorClass: 'error',
      submitButton: '*[type=submit]',
      disableSubmit: false
    }, settings);

    this.forms = document.querySelectorAll(this.options.formsClass);
    this.forms.forEach(form => {
      if (form) {
        const submitBtn = form.querySelector('.footer-newsletter__button');
        const requiredInput = form.querySelector('.newsletter-form__holder input[name="agreement-required"]');
        const optionInput = form.querySelector('.newsletter-form__holder input[name="agreement-option"]');
        const thirdpartyInput = form.querySelector('.newsletter-form__holder input[name="agreement-thirdparty"]');
        const hiddenInput = form.querySelector('.newsletter-form__tag');

        requiredInput.addEventListener('change', () => {
          this.updateButtonStatus(requiredInput.checked, submitBtn);
          this.updateHiddenInputValue(requiredInput.checked, optionInput.checked, thirdpartyInput.checked, hiddenInput);
        });

        optionInput.addEventListener('change', () => {
          this.updateHiddenInputValue(requiredInput.checked, optionInput.checked, thirdpartyInput.checked, hiddenInput);
        });
        
        thirdpartyInput.addEventListener('change', () => {
          this.updateHiddenInputValue(requiredInput.checked, optionInput.checked, thirdpartyInput.checked, hiddenInput);
        });
      }
    });
  }

  updateButtonStatus(status, btn) {
    !status ? btn.setAttribute('disabled', '') : btn.removeAttribute('disabled');
  }

  updateHiddenInputValue(isRequiredChecked, isOptionChecked, isThirdPartyChecked, hiddenInput) {
    if (isRequiredChecked && isOptionChecked && isThirdPartyChecked) {
      hiddenInput.value = "acceptCustomerProfiling,acceptThirdParties,newsletter";
    } else if (isRequiredChecked && isOptionChecked) {
      hiddenInput.value = "acceptCustomerProfiling,newsletter";
    } else if (isRequiredChecked && isThirdPartyChecked) {
      hiddenInput.value = "acceptThirdParties,newsletter";
    } else if (isRequiredChecked) {
      hiddenInput.value = "newsletter";
    } else {
      hiddenInput.value = "newsletter";
    }
  }
}

const defaultForm = new FormValidator();
